module.exports = {
	LOCAL: {
		KEY: `local`,
		VALUE: `Local`
	},
	DEVELOPMENT: {
		KEY: `dev`,
		VALUE: `Development`
	},
	ACCEPTANCE: {
		KEY: `acc`,
		VALUE: `Acceptance`
	},
	PREVIEW: {
		KEY: `prev`,
		VALUE: `Preview`
	},
	PRODUCTION: {
		KEY: `prod`,
		VALUE: `CP Admin`
	},
	NOT_FOUND: `ENVIRONMENT NOT DEFINED`
};
